import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3999be9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.idName,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode("Download " + _toDisplayString(_ctx.name), 1)
    ], true)
  ], 8, _hoisted_1))
}